var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnlarge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2917 80.0834V72.1667H72.1667V60.2917H80.0834V74.1459C80.0834 75.6897 79.4501 77.0751 78.2626 78.2626C77.0751 79.4501 75.6897 80.0834 74.1459 80.0834H60.2917ZM20.7084 80.0834H6.85425C5.3105 80.0834 3.92508 79.4501 2.73758 78.2626C1.55008 77.0751 0.916748 75.6897 0.916748 74.1459V60.2917H8.83341V72.1667H20.7084V80.0834ZM60.2917 0.916748H74.1459C75.6897 0.916748 77.0751 1.55008 78.2626 2.73758C79.4501 3.92508 80.0834 5.3105 80.0834 6.85425V20.7084H72.1667V8.83341H60.2917V0.916748ZM20.7084 0.916748V8.83341H8.83341V20.7084H0.916748V6.85425C0.916748 5.3105 1.55008 3.92508 2.73758 2.73758C3.92508 1.55008 5.3105 0.916748 6.85425 0.916748H20.7084ZM34.5626 16.7501C44.4584 16.7501 52.3751 24.6667 52.3751 34.5626C52.3751 38.0459 51.3855 41.2917 49.6438 44.0626L62.548 56.9667L56.9667 62.548L44.0626 49.6438C41.2917 51.3855 38.0459 52.3751 34.5626 52.3751C24.6667 52.3751 16.7501 44.4584 16.7501 34.5626C16.7501 24.6667 24.6667 16.7501 34.5626 16.7501ZM34.5626 24.6667C29.1001 24.6667 24.6667 29.1001 24.6667 34.5626C24.6667 40.0251 29.1001 44.4584 34.5626 44.4584C40.0251 44.4584 44.4584 40.0251 44.4584 34.5626C44.4584 29.1001 40.0251 24.6667 34.5626 24.6667Z",
    fill: "#FFF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnlarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Enlarge.0c3daa639e906cde43858401a701336d.svg";